import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {LabelPosition, Size, Themes} from '@usitsdasdesign/dds-ng/shared';
import {Mode, PaginationOptions} from '@usitsdasdesign/dds-ng/pagination';
import {SelectItemOptions, SelectOptions} from '@usitsdasdesign/dds-ng/select';
import {PaginatorInfo} from './paginator';
import { PreferencesCurrentViewService } from 'src/app/services/preferences/preferences-current-view';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorComponent {
  private readonly defaultOptions: PaginationOptions = {
    mode: Mode.text,
    pageNumberInSection: 5,
    size: 'md',
    theme: Themes.dark,
    isDisabled: false,
    ariaLabel: 'pagination',
    customClass: '',
  };
  options: PaginationOptions = {...this.defaultOptions};

  @Input()
  set paginatorOptions(options: PaginationOptions) {
    this.options = {...this.defaultOptions, ...(options || {})};
  }

  @Input() paginatorInfo: PaginatorInfo;
  @Output() pageChanged = new EventEmitter<number>();
  @Output() optionsChanged = new EventEmitter<number>();

  get renderedFirstIndex(): number {
    return (this.paginatorInfo.pageIndex - 1) * this.paginatorInfo.pageSize + 1;
  }

  get renderedCount(): number {
    const renderedCount: number = this.paginatorInfo.pageSize * this.paginatorInfo.pageIndex;
    return renderedCount > this.paginatorInfo.totalItems ? this.paginatorInfo.totalItems : renderedCount;
  }

  selectOptions: SelectOptions = {
    labelPosition: LabelPosition.external,
    size: Size.md,
    customClass: 'paginator__select-options',
  };

  selectItems: SelectItemOptions[] = [
    {
      heading: '20',
      value: 20,
      customClass: 'paginator__select-item',
    },
    {
      heading: '30',
      value: 30,
      customClass: 'paginator__select-item',
    },
    {
      heading: '40',
      value: 40,
      customClass: 'paginator__select-item',
    },
    {
      heading: '50',
      value: 50,
      customClass: 'paginator__select-item',
    },
  ];

  
initPageValue: number;

  constructor(private prefService: PreferencesCurrentViewService) {
    this.prefService.currentView$.subscribe((res) => {
     this.initPageValue = res?.recordsPerPage;
    });
  }

  updateOptions(pageSize: string): void {
    this.optionsChanged.emit(parseInt(pageSize, 10));
  }
}
